import { IdentificationIcon } from "@heroicons/react/24/outline";
import { ImageInput } from "Components/ImageInput";
import { Input } from "Components/Input";
import { UseFormHandleSubmit, UseFormRegister } from "react-hook-form";
import { useParams } from "react-router-dom";
import { FormState } from "./CouponsAddPage";
import { DateInput } from "../../Components/DateInput";
import {
  AdminPage,
  Card,
  AdminError,
  BackLink,
  Field,
  CategorySelect,
  PrimaryButton,
} from "./adminShared";

const CouponsAddForm = ({ handleFormSubmit, handleSubmit, register, errors, getValues, setValue, watch, error }: {
  handleFormSubmit: any, handleSubmit: UseFormHandleSubmit<FormState>,
  register: UseFormRegister<FormState>, errors: any, getValues: any, setValue: any, watch: any, error: string
}) => {
  const { hub_id } = useParams<{ hub_id: string }>();
  const category = watch("category") || "shop";

  return (
    <AdminPage eyebrow="COUPONS" title="クーポンを作成" icon="ticket" maxWidth={680}>
      <BackLink to={`/sponsor/hubs/${hub_id}/coupons`}>クーポン一覧に戻る</BackLink>
      <AdminError error={error} />
      <Card style={{ padding: 28 }}>
        <form method="POST" onSubmit={handleSubmit(handleFormSubmit)}>
          <input type="hidden" {...register("category")} />
          <div style={{ display: "flex", flexDirection: "column", gap: 22 }}>
            <Input
              label="クーポン名"
              name="title"
              register={register}
              required="クーポン名を入力してください"
              maxLength={{ value: 60, message: "クーポン名が長すぎます。" }}
              minLength={{ value: 2, message: "クーポン名が短すぎます。" }}
              pattern={{ value: /.+/, message: "クーポン名の形式が不正です。" }}
              autoComplete="title"
              password={false}
              placeholder=""
              icon={<IdentificationIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
              errors={errors.title}
            />

            <Input
              label="説明"
              name="description"
              register={register}
              required="説明を入力してください"
              maxLength={{ value: 200, message: "説明が長すぎます。" }}
              minLength={{ value: 1, message: "説明が短すぎます。" }}
              pattern={{ value: /.+/, message: "説明の形式が不正です。" }}
              autoComplete="description"
              password={false}
              placeholder="3000円以上お買い上げの方は5%オフになるクーポンです！"
              icon={<IdentificationIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
              errors={errors.description}
            />

            {/* カテゴリー */}
            <Field label="カテゴリー" required hint="クーポンが表示されるカテゴリーを選んでください。">
              <CategorySelect value={category} onChange={(v) => setValue("category", v)} />
            </Field>

            <ImageInput label="クーポン画像" required={true} name="image" watch={watch} getValues={getValues} setError setValue={setValue}></ImageInput>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
              <DateInput label="開始有効期限" required={true} name="period_start" watch={watch} setValue={setValue} />
              <DateInput label="終了有効期限" required={true} name="period_end" watch={watch} setValue={setValue} />
            </div>

            <Input
              label="発行数"
              name="stock"
              register={register}
              required="発行数を入力してください"
              maxLength={{ value: 5, message: "発行数が長すぎます。" }}
              minLength={{ value: 1, message: "発行数が短すぎます。" }}
              pattern={{ value: /^[0-9]+$/, message: "発行数の形式が不正です。" }}
              password={false}
              autoComplete=""
              placeholder="100"
              icon={<IdentificationIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
              errors={errors.stock}
            />
          </div>

          <PrimaryButton type="submit" style={{ width: "100%", marginTop: 28 }}>
            発行する
          </PrimaryButton>
        </form>
      </Card>
    </AdminPage>
  );
};

export default CouponsAddForm;
